export const CATEGORY_OPTIONS = [
    { value: "travel", label: "Travel" },
    { value: "office", label: "Office" },
    { value: "subsistence", label: "Subsistence" },
    { value: "staff", label: "Staff" },
    { value: "premises", label: "Premises" },
    { value: "repairs", label: "Repairs" },
    { value: "advertising", label: "Advertising" },
    { value: "interest", label: "Interest" },
    { value: "bank_charges", label: "Bank Charges" },
    { value: "professional_fees", label: "Professional Fees" },
    { value: "other", label: "Other" },
];
